// `CasePanel` for hosts (cloud opens a Case beside a message): the same
// component, its code (the Case's detail and the editor) loaded when a Case is
// first opened that way. Until then the panel shows a detail's skeleton.
import { lazyScreen, lazyView } from "../app/lazy";
import { DetailLoading } from "../shell/side-view";

export const CasePanel = lazyView(
  lazyScreen(() => import("./panel"), "CasePanel"),
  <DetailLoading />,
);
